<div>
  <kendo-grid #grid [kendoGridBinding]="gridData" [scrollable]="'true'" [resizable]="true">
    <!-- MOBILE VIEW -->
    <kendo-grid-column media="(max-width: 772.98px)" title="Details">
      <ng-template kendoGridCellTemplate let-dataItem>
        <dl>
          <dd>
            <div class="align-left">
              <span class="bold">Type: </span>
              <span> {{ dataItem.payrollType }}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">Fiscal Year: </span>
              <span> {{ dataItem.fiscalYear }}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">PPED: </span>
              <span *ngIf="dataItem.payPeriodEndDate; else noPPED">
                {{ dataItem.payPeriodEndDate | date: 'MM/dd/yyyy'}}</span>
              <ng-template #noPPED>
                <span>
                  --
                </span>
              </ng-template>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">Contribution: </span>
              <span [ngClass]=" 0 > dataItem.contributionAmount ? 'neg-amount' : ''"
                *ngIf="dataItem.contributionAmount; else noContribution">
                {{ dataItem.formatAmount }}</span>
              <ng-template #noContribution>
                <span>
                  --
                </span>
              </ng-template>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">HW: </span>
              <span> {{ dataItem.hoursWorked}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">SH: </span>
              <span> {{ dataItem.standardHours}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">PCT: </span>
              <span> {{ dataItem.percentage}}</span>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">AAComp: </span>
              <span *ngIf="dataItem.actualAnnualCompensation; else noAAC">
                {{ dataItem.actualAnnualCompensation | currency:'USD':'symbol':'1.0-2'}}</span>
              <ng-template #noAAC>
                <span>
                  --
                </span>
              </ng-template>
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">AEComp: </span>
              <span *ngIf="dataItem.actualEarnableCompensation; else noAEC">
                {{ dataItem.actualEarnableCompensation | currency:'USD':'symbol':'1.0-2'}}</span>
              <ng-template #noAEC>
                <span>
                  --
                </span>
              </ng-template>
            </div>
          </dd>
        </dl>
      </ng-template>
    </kendo-grid-column>
    <!-- PAYROLL TYPE -->
    <kendo-grid-column media="(min-width: 773px)" field="payrollType" title="Type" [width]="100">
    </kendo-grid-column>

    <!-- FISCAL YEAR -->
    <kendo-grid-column media="(min-width: 773px)" field="fiscalYear" title="Fiscal Year" [width]="100"
      [headerClass]="{'align-date': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-date">
          <span>
            {{dataItem.fiscalYear}}
          </span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <!-- PPED -->
    <kendo-grid-column media="(min-width: 773px)" field="payPeriodEndDate" title="PPED" [width]="100"
      [headerClass]="{'align-date': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-date" *ngIf="dataItem.payPeriodEndDate; else noPPED">
          {{dataItem.payPeriodEndDate | date: 'MM/dd/yyyy'}}
        </div>
        <ng-template #noPPED>
          <div class="align-date">
            --
          </div>
        </ng-template>
      </ng-template>
    </kendo-grid-column>

    <!-- EMP CONTRIBUTION -->
    <kendo-grid-column media="(min-width: 773px)" field="contributionAmount" title="Contribution" [width]="110"
      [headerClass]="{'align-number': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number" *ngIf="dataItem.contributionAmount; else noContribution">
          <span [ngClass]=" 0 > dataItem.contributionAmount ? 'neg-amount' : ''">
            {{dataItem.formatAmount}}
          </span>
        </div>
        <ng-template #noContribution>
          <div class="align-number">
            --
          </div>
        </ng-template>
      </ng-template>
    </kendo-grid-column>

    <!-- HOURS WORKED -->
    <kendo-grid-column media="(min-width: 773px)" field="hoursWorked" title="HW" [width]="60" format="{0:n1}"
      [headerClass]="{'align-number': true}" class="align-number"></kendo-grid-column>

    <!-- STANDARD HOURS -->
    <kendo-grid-column media="(min-width: 773px)" field="standardHours" title="SH" [width]="60" format="{0:n1}"
      [headerClass]="{'align-number': true}" class="align-number"></kendo-grid-column>

    <!-- PCT -->
    <kendo-grid-column media="(min-width: 773px)" field="percentage" title="PCT" [width]="60" format="{0:n0}"
      [headerClass]="{'align-number': true}" class="align-number"></kendo-grid-column>

    <!-- AAC -->
    <kendo-grid-column media="(min-width: 773px)" field="actualAnnualCompensation" title="AAComp" [width]="100"
      [headerClass]="{'align-number': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number" *ngIf="dataItem.actualAnnualCompensation; else noAAC">
          {{dataItem.actualAnnualCompensation | currency:'USD':'symbol':'1.0-2'}}</div>
        <ng-template #noAAC>
          <div class="align-number">
            --
          </div>
        </ng-template>
      </ng-template>
    </kendo-grid-column>

    <!-- AEC -->
    <kendo-grid-column media="(min-width: 773px)" field="actualEarnableCompensation" title="AEComp" [width]="100"
      [headerClass]="{'align-number': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-number" *ngIf="dataItem.actualEarnableCompensation; else noAEC">
          {{dataItem.actualEarnableCompensation | currency:'USD':'symbol':'1.0-2'}}</div>
        <ng-template #noAEC>
          <div class="align-number">
            --
          </div>
        </ng-template>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
